export default "/images/artist1.png?2bbfa2445b607425af60a4cc951b7d1a";